module.exports = __webpack_public_path__ + "img/signIn.8a649106.svg";